import { FC } from "react"
import spaceNumber from "utils/spaceNumber"
import "./index.scss"

interface SpaceNumberProps {
  amount?: number | string
}

const SpaceNumber: FC<SpaceNumberProps> = ({ amount = 0 }) => {
  const val = spaceNumber(amount).split(".")
  const val1 = val[0]
  const val2 = val[1]

  return (
    <>
      {val1}
      {val2 && (
        <>
          .<small>{val2}</small>
        </>
      )}
    </>
  )
}

export default SpaceNumber
